import React from "react"

import SidebarNavSection from "./SidebarNavSection"

const SidebarNav = ({ items }) => {
  return (
    <ul className="sidebar-nav" data-testid="sidebar-nav">
      {items &&
        items.map((item, key) => (
          <SidebarNavSection key={key} pages={item.pages} title={item.title} />
        ))}
    </ul>
  )
}

export default SidebarNav
